import helper from './helper';

export default function Select() {
    if (helper.isMobile) {
        document.body.classList.add('sst-select-fix');
    }

    document.addEventListener('click', clickHandler, false);
    document.addEventListener('change', chahgeHandler, false);
    document.addEventListener('keydown', escapeKeyHandler, false);
    window.addEventListener('resize', resizeHandler, false);

    const MINWIDTH = 200;
    const MAXHEIGHT = 8 * 40;
    const MINHEIGHT = 4 * 40;

    function clickHandler(e) {
        if (helper.isMobile) return;

        let fieldDisplay = e.target;
        let container = fieldDisplay.parentNode;

        /**
         * клик по .sst-field__display
         * открывает селект
         */
        if (hasClass(e.target, 'sst-field__display')) {
            e.preventDefault();

            if (!hasClass(container, 'sst-select--open')) {
                closeAll(container);
                addDropdown(container);
            } else {
                closeAll(null);
            }
        } else if (hasClass(e.target, 'sst-dropdown__option')) {
        /**
         * клик по option
         */
            let wrapper = e.target.parentNode;
            let stamp = wrapper.getAttribute('data-for-select-id');
            let select = document.querySelector(
                '[ data-select-id = "' + stamp + '" ]'
            );
            let option = select.querySelectorAll('option')[
                e.target.getAttribute('data-index')
            ];

            if (select.hasAttribute('multiple')) {
                e.target.classList.toggle('sst-active');
                option.selected = hasClass(e.target, 'sst-active');
            } else {
                option.selected = true;
                helper.triggerEvent(select, 'change');
                closeAll(null);
            }
        } else {
            closeAll(null);
        }
    }

    function closeAll(exceptSelect) {
        let arrayOfOpenedSelects = document.querySelectorAll(
            '.sst-select--open'
        );

        [].filter
            .call(arrayOfOpenedSelects, (elem) => {
                return elem !== exceptSelect;
            })
            .forEach((elem) => {
                removeClass(elem, 'sst-select--open');
            });

        detachDropDown();
    }

    // изменение инпута
    function chahgeHandler(e) {
        if (
            hasClass(e.target, 'sst-field__input') &&
            e.target.tagName == 'SELECT'
        ) {
            let selected = e.target.querySelectorAll('option:checked')[0];
            let data = {};
            let dataAttrs = [].filter.call(selected.attributes, (attr) =>
                /^data-/.test(attr.name)
            );
            let parent = e.target.parentNode;
            let display = e.target.parentNode.querySelector(
                '.sst-field__display'
            );

            removeClass(parent, 'sst-select--open');
            display.textContent = selected.textContent;
            display.setAttribute('data-dirty', true);

            removeClass(e.target, 'sst-field--has-error');

            // for(let key in attrs){
            // 	if( attrs[key].nodeName !== 'value' && attrs[key].nodeName !== undefined){
            // 		e.target.setAttribute( attrs[key].nodeName, attrs[key].nodeValue )
            // 	}
            // }

            forEach(dataAttrs, (index, attr) => {
                data[normalizeDataAttrName(attr.nodeName)] = attr.nodeValue;
            });

            e.target.data = data;

            setTimeout(() => {
                helper.triggerEvent(e.target, 'sst-select-change');
            }, 0);
        }
    }

    function resizeHandler() {
        let dropdownWrapper =
            document.querySelectorAll('.sst-dropdown')[0] || null;
        let stamp;
        let select;
        let container;

        if (dropdownWrapper !== null) {
            stamp = dropdownWrapper.getAttribute('data-for-select-id');
            select =
                document.querySelector(
                    '[ data-select-id = "' + stamp + '" ]'
                ) || [];
            container = select.parentNode;

            dropdownWrapper.style.top =
                container.getBoundingClientRect().top +
                container.offsetHeight +
                window.pageYOffset +
                'px';
            dropdownWrapper.style.maxHeight = calcMaxHeight(container);
            dropdownWrapper.style.left = calcPosition(container).left;
            dropdownWrapper.style.width = container.offsetWidth + 'px';
        }
    }

    function addDropdown(container) {
        let select = container.querySelector('select');
        let optionElementList = select.querySelectorAll('option');
        let dropdownWrapper = document.createElement('div');
        let stamp = Date.now();
        let isMultiple = select.hasAttribute('multiple');

        if (select.disabled) return;

        select.setAttribute('data-select-id', stamp);
        dropdownWrapper.setAttribute('data-for-select-id', stamp);

        addClass(dropdownWrapper, 'sst-dropdown');

        if (isMultiple) {
            dropdownWrapper.setAttribute('data-multiple', 'true');
        }

        forEach(optionElementList, (i, item) => {
            let dropdownInner = document.createElement('div');
            let textContent = item.textContent;

            dropdownInner.textContent = textContent;
            dropdownInner.setAttribute('data-index', i);

            addClass(dropdownInner, 'sst-dropdown__option');

            if (item.selected) {
                addClass(dropdownInner, 'sst-active');
            }
            dropdownWrapper.appendChild(dropdownInner);
        });

        helper.triggerEvent(select, 'beforeOpen');

        document.body.appendChild(dropdownWrapper);

        dropdownWrapper.style.position = 'absolute';
        dropdownWrapper.style.minWidth = MINWIDTH + 'px';
        dropdownWrapper.style.top = calcPosition(container).top;
        dropdownWrapper.style.left = calcPosition(container).left;
        dropdownWrapper.style.minHeight = calcMinHeight(dropdownWrapper);
        dropdownWrapper.style.maxHeight = calcMaxHeight(container);
        dropdownWrapper.style.width = container.offsetWidth + 'px';
        dropdownWrapper.style.zIndex = 20002;

        setTimeout(() => {
            addClass(dropdownWrapper, 'sst-active');
            addClass(container, 'sst-select--open');
        }, 0);
    }

    function calcPosition(container) {
        let offsetTop = getOffset(container).top;
        let offsetLeft = getOffset(container).left;

        let scrollTop = window.pageYOffset;
        let scrollLeft = window.pageXOffset;

        let left = 0;
        let top = offsetTop + container.offsetHeight + window.pageYOffset;

        if (
            viewport().width - MINWIDTH > offsetLeft ||
            container.offsetWidth >= MINWIDTH
        ) {
            left = offsetLeft + scrollLeft;
        } else {
            left = offsetLeft + scrollLeft + container.offsetWidth - MINWIDTH;
        }

        return {
            top: top + 'px',
            left: left + 'px',
        };
    }

    function calcMinHeight(el) {
        let height = el.offsetHeight;

        if (height > MINHEIGHT) {
            return MINHEIGHT + 'px';
        } else {
            return height + 'px';
        }
    }

    function calcMaxHeight(container) {
        let offsetTop = getOffset(container).top;
        let _maxHeight =
            viewport().height +
            window.pageYOffset -
            offsetTop -
            container.offsetHeight -
            window.pageYOffset;

        if (_maxHeight > MAXHEIGHT) {
            return MAXHEIGHT + 'px';
        } else {
            return _maxHeight + 'px';
        }
    }

    function escapeKeyHandler(e) {
        if (e.keyCode == 27) {
            closeAll(null);
        }
    }

    function detachDropDown() {
        let elements = document.querySelectorAll('.sst-dropdown');
        forEach(elements, function (i, element) {
            element.parentNode.removeChild(element);
        });
    }

    /**
     * https://toddmotto.com/ditch-the-array-foreach-call-nodelist-hack/
     */
    function forEach(array, callback, scope) {
        for (var i = 0; i < array.length; i++) {
            callback.call(scope, i, array[i]);
        }
    }

    function hasClass(el, className) {
        if (el.classList) return el.classList.contains(className);
        else
            return new RegExp('(^| )' + className + '( |$)', 'gi').test(
                el.className
            );
    }

    function addClass(el, className) {
        if (el.classList) return el.classList.add(className);
        else return (el.className += ' ' + className);
    }

    function removeClass(el, className) {
        if (el.classList) return el.classList.remove(className);
        else
            return (el.className = el.className.replace(
                new RegExp(
                    '(^|\\b)' + className.split(' ').join('|') + '(\\b|$)',
                    'gi'
                ),
                ' '
            ));
    }

    function normalizeDataAttrName(string) {
        return string.replace(/^data-/g, '').replace(/(\-\w)/g, function () {
            return arguments[0][1].toUpperCase();
        });
    }

    function viewport() {
        let height;
        let width;

        if (document.compatMode === 'BackCompat') {
            height = document.body.clientHeight;
            width = document.body.clientWidth;
        } else {
            height = document.documentElement.clientHeight;
            width = document.documentElement.clientWidth;
        }

        return {
            width: width,
            height: height,
        };
    }

    function getOffset(el) {
        return {
            top: el.getBoundingClientRect().top,
            left: el.getBoundingClientRect().left,
        };
    }
}
